// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_REJ_REGISTRAR_SVC, SUC_REJ_REGISTRAR_SVC } from '../../../../utils/strings';

export const useRejectRegistrarServiceRequest = () => {
  const { submit } = useExerciseSubmission(
    RegistrarServiceRequest.RegistrarServiceRequest_Reject,
    SUC_REJ_REGISTRAR_SVC,
    ERR_REJ_REGISTRAR_SVC,
  );
  return submit;
};
